import { IMenu } from "pages/[tenant]/cp/@types";

export const filterMenulistByActiveItem = (menu: IMenu[]): IMenu[] => {
  const filteredMenu = menu?.filter((item) => item?.active);

  return filteredMenu;
};
